<script>
export default {}
</script>

<template>
  <div class ="all-page">
    <div class="page-wrap">
      <s-load-fonts></s-load-fonts>
      <div class="page-container">
        <router-view></router-view>
        <portal-target name="modal" multiple></portal-target>
      </div>
    </div>
  </div>
  
</template>

<style lang="scss" scoped>
@import 'main-layout.scss';
</style>
